import { PrivacyBadge, Privacy } from '@brandfolder/react';
import React, { FunctionComponent } from 'react';

interface ResourcePrivacyBadgeProps {
  privacy: string;
}

export const ResourcePrivacyBadge: FunctionComponent<ResourcePrivacyBadgeProps> = ({ privacy }) => (
  <>
    {privacy === 'private' && (
      <PrivacyBadge privacyLevel={Privacy.Private} showIcon showText={false}>
        {bfTranslate('Private')}
      </PrivacyBadge>
    )}
    {privacy === 'stealth' && (
      <PrivacyBadge privacyLevel={Privacy.Stealth} showIcon showText={false}>
        {bfTranslate('Stealth')}
      </PrivacyBadge>
    )}
    {privacy === 'public' && (
      <PrivacyBadge privacyLevel={Privacy.Public} showIcon showText={false}>
        {bfTranslate('Public')}
      </PrivacyBadge>
    )}
  </>
);